import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

// material-ui
import { useTheme } from '@mui/material/styles';
import {
  Box, Grid, Tab, Tabs, Backdrop, CircularProgress
  ,
} from '@mui/material';

// project imports
import Profile from './Profile';
import Phones from './Phones';
import Clothes from './Clothes';
import Certificate from './Certificate';
import EmployeeHistory from './EmployeeHistory'
import History from './History';
import MainCard from 'src/components/cards/MainCard';
import Education from './Education';
import EducationalExpertise from './EducationalExpertise';
import Documentation from './Documentation';
import Experience from './Experience';
import KocAilemUygunluk from './KocAilemUygunluk';
import Gdpr from './Gdpr';
import Transfer from './Transfer';
import Header from './Header';
import axios from 'src/utils/axios';

// assets
import AccountCircleTwoToneIcon from '@mui/icons-material/AccountCircleTwoTone';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import CheckroomIcon from '@mui/icons-material/Checkroom';
import ManageHistoryIcon from '@mui/icons-material/ManageHistory';
import SchoolIcon from '@mui/icons-material/School';
import FolderCopyIcon from '@mui/icons-material/FolderCopy';
import { getUser } from 'src/utils/Common';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import DirectionsRunIcon from '@mui/icons-material/DirectionsRun';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import TransferWithinAStationIcon from '@mui/icons-material/TransferWithinAStation';
// Import
import 'react-confirm-alert/src/react-confirm-alert.css';
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import WorkHistoryIcon from '@mui/icons-material/WorkHistory';
import SecurityIcon from '@mui/icons-material/Security';

// tabs panel
function TabPanel({ children, value, index, ...other }) {
  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`
  };
}

// tabs option




// ==============================|| PROFILE 1 ||============================== //

const styles = {
  ul: {
    '& .MuiPaginationItem-root': {
      '&.Mui-selected': {
        background: '#FF9800',
        color: 'white',
        borderRadius: '50%',
      },
    },
  },
  backdrop: (theme) => ({
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  }),
};

// SP bit alanlarını JSON'a true/false da '1'/'0' da döndürebiliyor.
const toBool = (value) => value === true || value === 1 || value === '1' || value === 'true';

const Profile1 = ({ EmployeeNr, OrganizationTypeId, ServiceShopId, NewEmployeeGet1 = () => {}, Name, Surname, PersonelType, StateId, PersonelKocAilemStatus }) => {


  const theme = useTheme();
  const [value, setValue] = useState(0);
  const [loading, setLoading] = useState(false);
  const [NameParam, setNameParam] = useState(Name);
  const [SurnameParam, setSurnameParam] = useState(Surname);
  const [StatusParam, setStatusParam] = useState(StateId);
  const [PersonelTypeParam, setPersonelTypeParam] = useState(PersonelType);
  const [Warning, setWarning] = useState(false);
  const [WarningType, setWarningType] = useState('default');
  const [responseMessage, setresponseMessage] = useState("");
  const SessionUser = getUser();
  const [kocAilemBaslatilabilir, setKocAilemBaslatilabilir] = useState(false);
  const [evrakKontrolMuaf, setEvrakKontrolMuaf] = useState(false);
  const [kocAilemKapsamDisi, setKocAilemKapsamDisi] = useState(false);
  // Sekme görünürlüğü artık iki ayrı async koşula bağlı (muafiyet + kapsam dışı). Cevap
  // gelmeden sekmeyi çizmek, `ofs` tüm sekme index'lerini kaydırdığı için o anda tıklayan
  // kullanıcıyı yanlış sekmeye düşürüyordu. Bu yüzden cevap gelene kadar sekme çizilmiyor.
  const [kocAilemBilgiYuklendi, setKocAilemBilgiYuklendi] = useState(false);

  // GetKocAilemUygunluk sadece Bayi (OrganizationTypeId = 2) çalışanları için veri
  // döndürüyor. Hem Header'daki Koç Ailem butonu hem de "Koç Ailem Durumu" sekmesi aynı
  // cevaba bağlı olduğu için istek burada tek sefer atılıp aşağıya aktarılıyor.
  useEffect(() => {
    if (Number(OrganizationTypeId) !== 2) {
      setKocAilemBaslatilabilir(false);
      setEvrakKontrolMuaf(false);
      setKocAilemKapsamDisi(false);
      setKocAilemBilgiYuklendi(false);
      return;
    }
    setKocAilemBilgiYuklendi(false);
    axios.get(`GetKocAilemUygunluk/${EmployeeNr}`).then((response) => {
      setKocAilemBaslatilabilir(toBool(response?.data?.UyelikBaslatilabilirMi));
      setEvrakKontrolMuaf(toBool(response?.data?.EvrakKontrolMuafMi));
      setKocAilemKapsamDisi(toBool(response?.data?.KocAilemKapsamDisiMi));
      setKocAilemBilgiYuklendi(true);
    }).catch(() => {
      // Cevap alınamadıysa çalışanın satış bölgesini bilemiyoruz; Koç Ailem işlemi
      // sunmak yerine kapalı tarafta kalıyoruz (Koç Ailem ekranı da aynı uca bağlı
      // olduğu için zaten çalışmazdı).
      setKocAilemBaslatilabilir(false);
      setEvrakKontrolMuaf(false);
      setKocAilemKapsamDisi(false);
      setKocAilemBilgiYuklendi(false);
    });
  }, [EmployeeNr, OrganizationTypeId]);

  // "Koç Ailem Durumu" sekmesi "Çalışan"dan hemen sonra geliyor. Gösterilmediği durumlar:
  // - evrak kontrolünden muaf roller (Bayi Sahibi/Ortak, Bayi Sahibi/Yönetici Ortak):
  //   uygunluk kuralları hiç değerlendirilmiyor,
  // - bayinin satış bölgesi kapsam dışı: Koç Ailem işlemi hiç yapılmamalı.
  const kocAilemSekmesiVar =
    OrganizationTypeId !== 1 && kocAilemBilgiYuklendi && !evrakKontrolMuaf && !kocAilemKapsamDisi;
  // Sekme index'leri bu dosyada elle yazıldığı için, araya eklenen sekme "Çalışan"dan
  // sonraki her şeyi bir kaydırıyor. Tek kaynak burası olsun diye offset kullanılıyor.
  const ofs = kocAilemSekmesiVar ? 1 : 0;

  const tabsOption = [
    {
      label: 'Çalışan',
      icon: <AccountCircleTwoToneIcon sx={{ fontSize: '1.3rem' }} />
    },
    ...(kocAilemSekmesiVar ? [{
      label: 'Koç Ailem Durumu',
      icon: <FactCheckIcon sx={{ fontSize: '1.3rem' }} />
    }] : []),
    {
      label: 'İletişim',
      icon: <ContactPhoneIcon sx={{ fontSize: '1.3rem' }} />
    },
    {
      label: 'İletişim İzni',
      icon: <SecurityIcon sx={{ fontSize: '1.3rem' }} />
    },
    {
      label: 'Kıyafet',
      icon: <CheckroomIcon sx={{ fontSize: '1.3rem' }} />
    },
    // Diğer sekmeler
    {
      label: 'Eğitimler',
      icon: <SchoolIcon sx={{ fontSize: '1.3rem' }} />
    },
    {
      label: 'Eğitim Uzmanlıkları',
      icon: <HistoryEduIcon sx={{ fontSize: '1.3rem' }} />
    },
    // `OrganizationTypeId` değeri 1 ise doküman sekmesini ekleyin
    ...(OrganizationTypeId === 1 ? [{
      label: 'Dokümanlar',
      icon: <FolderCopyIcon sx={{ fontSize: '1.3rem' }} />
    }] : []),
    {
      label: 'Tarihçe',
      icon: <WorkHistoryIcon sx={{ fontSize: '1.3rem' }} />
    },
    {
      label: 'Çalışan Log',
      icon: <ManageHistoryIcon sx={{ fontSize: '1.3rem' }} />
    },
    {
      label: 'Berat',
      icon: <CardGiftcardIcon sx={{ fontSize: '1.3rem' }} />
    },
    {
      label: 'Tecrübe',
      icon: <DirectionsRunIcon sx={{ fontSize: '1.3rem' }} />
    },
    ...(OrganizationTypeId === 1 ? [{
      label: 'Transfer',
      icon: <TransferWithinAStationIcon sx={{ fontSize: '1.3rem' }} />
    }] : []),
  ];



  

  // Muafiyet bilgisi istekle geldiği için sekme listesi mount'tan sonra kısalabiliyor.
  // Seçili index listenin dışında kalırsa boş panel görünmesin diye başa dönülüyor.
  useEffect(() => {
    if (value > tabsOption.length - 1) {
      setValue(0);
    }
  }, [tabsOption.length, value]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  // const handleKvkk = () => {
  //   confirmAlert({
  //     message: EmployeeNr.toString() + " numaralı " + Name + " " + Surname + " isimli çalışan olarak belirtilen " + KvkkPhone.toString() + " telefon numarasına KVKK doğrulanması için sms gönderilecektir.Çalışan KVKK onayı verdikten sonra işlemlerinize devam edebilirsiniz. Devam etmek istiyor musunuz?",
  //     buttons: [
  //       {
  //         label: 'Evet',
  //         onClick: () => handleKvkkYes()
  //       },
  //       {
  //         label: 'Hayır',
  //         onClick: () => { return; }
  //       }
  //     ]
  //   });
  // };



  // const handleKvkkYes = () => {
  //   setLoading(true);
  //   axios.get(`SetEmployeeKvkk/${EmployeeNr}/${KvkkPhone}`).then((response) => {
  //     setresponseMessage('İşleminiz başarı ile gerçekleştirildi!...');
  //     setWarning(true);
  //     setWarningType("success")
  //     NewEmployeeGet1(EmployeeNr);
  //     setLoading(false);
  //   });
  // };

  // const handleKvkkEmail = () => {
  //   if (!isValidEmail(KvkkEmail)) {
  //     setresponseMessage('Sisteme kaydedilmiş eposta adresi yanlış. Lütfen diğer yöntemlerle doğrulama yapınız.');
  //     setWarning(true);
  //     setWarningType("error");
  //     return;
  //   }

  //   confirmAlert({
  //     message: EmployeeNr.toString() + " numaralı çalışan olarak belirtilen " + KvkkEmail.toString() + " email adresine kvkk doğrulanması için mail gönderilecektir.Çalışan KVKK onayı verdikten sonra işlemlerinize devam edebilirsiniz. Devam etmek istiyor musunuz?",
  //     buttons: [
  //       {
  //         label: 'Evet',
  //         onClick: () => handleKvkkEmailYes()
  //       },
  //       {
  //         label: 'Hayır',
  //         onClick: () => { return; }
  //       }
  //     ]
  //   });
  // };

  // const handleKvkkEmailYes = () => {
  //   setLoading(true);
  //   axios.get(`SetEmployeeKvkkEmail/${EmployeeNr}/${KvkkEmail}`).then((response) => {
  //     if (response.data == "200") {
  //       setresponseMessage('İşleminiz başarı ile gerçekleştirildi!...');
  //       setWarning(true);
  //       setWarningType("success")
  //       NewEmployeeGet1(EmployeeNr);
  //     }
  //     else {
  //       setresponseMessage(response.data);
  //       setWarning(true);
  //       setWarningType("error");
  //     }
  //     setLoading(false);
  //   });
  // };

  const WarningClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setWarning(false);
  };


  const NewEmployeeGet = (EmployeeNrParam, Name, Surname, Status) => {
    if (EmployeeNrParam > 0) {
      NewEmployeeGet1(EmployeeNrParam);
    } else {
      setNameParam(Name);
      setSurnameParam(Surname);
      setStatusParam(Status);
      // setPersonelTypeParam(PersonelType);
    }

  }

  function isValidEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  // if (Kvkk === 0) {
  //   return <MainCard style={{ minHeight: 600, maxHeight: 600 }}>
  //     {
  //       loading ?
  //         <Backdrop className={classes.backdrop} open={loading}>
  //           <CircularProgress color="inherit" />
  //         </Backdrop>
  //         : <div></div>
  //     }
  //     <Grid container spacing={2}>
  //       <Snackbar
  //         open={Warning}
  //         autoHideDuration={10000}
  //         onClose={WarningClose}
  //         anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
  //       >
  //         <AlertComponent onClose={WarningClose} variant={WarningType} message={responseMessage}></AlertComponent>
  //       </Snackbar>
  //       <Grid item xs={12}>
  //         <SubCard title="Kvkk Onay İşlemleri">
  //           <Grid container spacing={2}>
  //             <Grid item xs={12}>
  //               <TextField type="phone"
  //                 disabled
  //                 value={KvkkPhone}
  //                 id="outlined-basic9" fullWidth label="Telefon Numarası" />
  //             </Grid>
  //             <Grid item xs={12}>
  //               <TextField type="email"
  //                 disabled
  //                 value={KvkkEmail}
  //                 id="outlined-basic9" fullWidth label="E-Posta Adresi"
  //               />
  //             </Grid>
  //             <Grid item xs={12}>
  //               <Stack direction="row" gap={2}>
  //                 <Button variant="contained"
  //                   color="secondary"
  //                   style={{ textTransform: 'none' }}
  //                   startIcon={<SendToMobileIcon />}
  //                   onClick={handleKvkk}
  //                 >
  //                   Kvkk Onay Sms Gönder
  //                 </Button>
  //                 <Button variant="contained"
  //                   color="secondary"
  //                   style={{ textTransform: 'none' }}
  //                   startIcon={<MailIcon />}
  //                   onClick={handleKvkkEmail}
  //                 >
  //                   Kvkk Onay E-Posta Gönder
  //                 </Button>

  //               </Stack>
  //             </Grid>
  //           </Grid>
  //         </SubCard>
  //         <br />
  //         <SubCard title="Kvkk Onay Metni">
  //           <Grid container spacing={2}>
  //             <Grid item xs={12}>
  //               <Paper style={{
  //                 maxHeight: '250px',
  //                 overflowY: 'auto',
  //                 padding: theme.spacing(2),
  //               }}>
  //                 <Typography variant="h5" component="h1" gutterBottom>
  //                   <strong style={{ color: 'red' }}>Arçelik A.Ş.</strong>
  //                 </Typography>
  //                 <Typography variant="body1" gutterBottom>
  //                   <strong>Sayın Çalışan,</strong>
  //                 </Typography>
  //                 <Typography variant="body1" gutterBottom>
  //                   Kişisel Veri Koruma Kanunu (KVKK) kapsamında, Arçelik A.Ş. olarak sizin kişisel verilerinizi korumak ve gizliliğinizi sağlamak için elimizden gelen tüm çabayı gösteriyoruz. Bu doğrultuda, kişisel verilerinizin işlenmesine ilişkin sizden açık ve bilgilendirilmiş bir şekilde onay almak istiyoruz.
  //                 </Typography>
  //                 <Typography variant="body1" gutterBottom>
  //                   Aşağıda belirtilen kişisel verilerinizin toplanması, kullanılması ve saklanması ile ilgili olarak sizden onay talep ediyoruz:
  //                 </Typography>
  //                 <List>
  //                   <ListItem>
  //                     <ListItemText primary="Adı ve Soyadı:" />
  //                   </ListItem>
  //                   <ListItem>
  //                     <ListItemText primary="Doğum Tarihi:" />
  //                   </ListItem>
  //                   <ListItem>
  //                     <ListItemText primary="Cinsiyet:" />
  //                   </ListItem>
  //                   <ListItem>
  //                     <ListItemText primary="İletişim Bilgileri (Telefon numarası, E-posta adresi, vb.):" />
  //                   </ListItem>
  //                   <ListItem>
  //                     <ListItemText primary="Adres:" />
  //                   </ListItem>
  //                   <ListItem>
  //                     <ListItemText primary="Meslek ve Şirket Bilgileri (varsa):" />
  //                   </ListItem>
  //                   <ListItem>
  //                     <ListItemText primary="Diğer ilgili bilgiler (varsa):" />
  //                   </ListItem>
  //                 </List>
  //                 <Typography variant="body1" gutterBottom>
  //                   Yukarıda belirtilen kişisel verilerin toplanma amacı, Arçelik A.Ş. hizmetleriyle ilgili size daha iyi hizmet sunabilmek, size özel teklifler sunmak, müşteri deneyimini geliştirmek ve yasal gerekliliklerimizi yerine getirmektir.
  //                 </Typography>
  //                 <Typography variant="body1" gutterBottom>
  //                   Toplanan kişisel verileriniz, yürürlükteki mevzuata uygun olarak, KVKK'ya uygun şekilde ve yalnızca belirtilen amaçlar doğrultusunda kullanılacak, işlenecek ve saklanacaktır. Kişisel verileriniz üçüncü kişilere, kurumlara ve kuruluşlara izniniz olmadan açıklanmayacak veya aktarılmayacaktır.
  //                 </Typography>
  //                 <Typography variant="body1" gutterBottom>
  //                   KVKK kapsamında, kişisel verilerinize erişim hakkınızı kullanabilir, verilerinizin düzeltilmesini veya silinmesini talep edebilir, verilerinizin işlenmesini sınırlandırabilir ve rıza verdiğiniz amaçlar doğrultusunda verilerinizin aktarılmasını isteyebilirsiniz. Bu tür talepleriniz için Arçelik A.Ş. ile iletişime geçebilirsiniz.
  //                 </Typography>
  //                 <Typography variant="body1" gutterBottom>
  //                   Ayrıca, işbu onayınızı istediğiniz zaman geri çekebilirsiniz. Bu durumda, verileriniz, çekilen onayınızı takip eden en kısa sürede işlenmeyi durduracak ve silinecektir.
  //                 </Typography>
  //                 <Typography variant="body1" gutterBottom>
  //                   KVKK kapsamında kişisel verilerimin işlenmesine dair bu onay metnini okudum ve içeriğini anladım. Gönüllü olarak rızamı veriyorum.
  //                 </Typography>

  //                 <Typography variant="body1" gutterBottom>
  //                   Saygılarımızla,
  //                   <br />
  //                   Arçelik A.Ş.
  //                 </Typography>
  //               </Paper>
  //             </Grid>
  //           </Grid>
  //         </SubCard>
  //       </Grid>
  //     </Grid>
  //   </MainCard>;
  // }

  return (
    <MainCard>
      {
        loading ?
          <Backdrop sx={styles.backdrop} open={loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
          : <div></div>
      }
      <Grid container spacing={2}>
        <Grid size={12}>
          <Header EmployeeNr={EmployeeNr}
            OrganizationId={ServiceShopId}
            Name={NameParam}
            Surname={SurnameParam}
            PersonelType={PersonelTypeParam}
            StateId={StatusParam}
            // Kvkk={Kvkk}
            PersonelKocAilemStatus={PersonelKocAilemStatus}
            OrganizationTypeId={OrganizationTypeId}
            KocAilemBaslatilabilir={kocAilemBaslatilabilir}
            KocAilemKapsamDisi={kocAilemKapsamDisi}
          />
        </Grid>
        <Grid size={12}>
          <Tabs
            value={value}
            TabIndicatorProps={{
              sx: {
                backgroundColor: '#FF9800',
              },
            }}
            textColor="primary"
            onChange={handleChange}
            aria-label="simple tabs example"
            variant="scrollable"
            sx={{
              mb: 3,
              '& a': {
                minHeight: 'auto',
                minWidth: 10,
                py: 1.5,
                px: 1,
                mr: 2.25,
                color: theme.palette.grey[600],
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'center'
              },
              '& a.Mui-selected': {
                color: '#FF9800'
              },
              '& .MuiTabs-indicator': {
                bottom: 2
              },
              '& a > svg': {
                marginBottom: '0px !important',
                mr: 1.25
              }
            }}
          >
            {tabsOption.map((tab, index) => (
              <Tab key={index} component={Link} to="#" icon={tab.icon} label={tab.label} {...a11yProps(index)} />
            ))}
          </Tabs>
          <TabPanel value={value} index={0}>
            <Profile EmployeeNr={EmployeeNr}
              OrganizationTypeId={OrganizationTypeId}
              OrganizationId={ServiceShopId}
              NewEmployeeGet={NewEmployeeGet}
              KocAilemKapsamDisi={kocAilemKapsamDisi}
            />
          </TabPanel>
          {kocAilemSekmesiVar && (
            <TabPanel value={value} index={1}>
              <KocAilemUygunluk EmployeeNr={EmployeeNr} />
            </TabPanel>
          )}
          <TabPanel value={value} index={1 + ofs} >
            <Phones EmployeeNr={EmployeeNr} />
          </TabPanel>
          <TabPanel value={value} index={2 + ofs}>
            <Gdpr EmployeeNr={EmployeeNr}
              OrganizationTypeId={OrganizationTypeId}
            />
          </TabPanel>
          <TabPanel value={value} index={3 + ofs}>
            <Clothes EmployeeNr={EmployeeNr} />
          </TabPanel>
          {/* <TabPanel value={value} index={3}>
            <Expense
              EmployeeNr={EmployeeNr}
              ServiceShopId={ServiceShopId}
            />
          </TabPanel> */}
          <TabPanel value={value} index={4 + ofs}>
            <Education EmployeeNr={EmployeeNr} />
          </TabPanel>
          <TabPanel value={value} index={5 + ofs}>
            <EducationalExpertise EmployeeNr={EmployeeNr} />
          </TabPanel>
          {OrganizationTypeId === 1 && (
            <TabPanel value={value} index={6}>
              <Documentation EmployeeNr={EmployeeNr} />
            </TabPanel>
          )}
          <TabPanel value={value} index={(OrganizationTypeId === 1 ? 7 : 6) + ofs}>
            <History EmployeeNr={EmployeeNr}
              OrganizationTypeId={OrganizationTypeId} />
          </TabPanel>
          <TabPanel value={value} index={(OrganizationTypeId === 1 ? 8 : 7) + ofs}>
            <EmployeeHistory EmployeeNr={EmployeeNr} />
          </TabPanel>
          <TabPanel value={value} index={(OrganizationTypeId === 1 ? 9 : 8) + ofs}>
            <Certificate EmployeeNr={EmployeeNr} OrganizationTypeId={OrganizationTypeId} />
          </TabPanel>
          <TabPanel value={value} index={(OrganizationTypeId === 1 ? 10 : 9) + ofs}>
            <Experience EmployeeNr={EmployeeNr} />
          </TabPanel>
          {/* Transfer yalnızca serviste (OrganizationTypeId = 1) görünüyor, orada
              "Koç Ailem Durumu" sekmesi hiç olmadığı için ofs zaten 0. */}
          <TabPanel value={value} index={11}>
            <Transfer EmployeeNr={EmployeeNr} OrganizationTypeId={OrganizationTypeId} EmployeeType={PersonelTypeParam} />
          </TabPanel>
        </Grid>
      </Grid>
    </MainCard>
  );
};

Profile1.propTypes = {
  NewEmployeeGet1: PropTypes.func,
};

export default Profile1;
